import React from 'react'
import PropTypes from 'prop-types'
import { Flex, NumericInput, LabelGroup, Section } from '~/views';
import BaseTimerEditor from './BaseTimerEditor'
import style from './style.css'
import { TimerActionFactory } from '../timerAction'

export default class RepeatingTimerEditor extends React.Component {
  static propTypes = {
    timer : PropTypes.object,
    currentContext : PropTypes.object,
    onChange : PropTypes.func.isRequired
  }

  static TYPE = 'repeating'

  static DEFAULTS = {
    type : 'repeating',
    delay : 10000,
    runImmediately : false
  }

  onRunImmediatelyClick = ( evt ) => {
    if ( this.baseTimer ) {
      this.baseTimer.changePath( 'timer/runImmediately', evt.target.checked )
    }
  }

  changePath = ( path, value, err ) => {
    console.log( path, value, err )
    if ( err ) {
      console.log( `error setting ${key} to ${value}` )
      return
    }
    if ( typeof this.props.onChange === 'function' ) {
      this.props.onChange( { target : this.props.timer, path, value } );
    }
  }

  render() {
    const { timer, currentContext } = this.props
    const timerObj = timer.timer
    return (
      <div className={style.container}>
        <BaseTimerEditor ref={ref => this.baseTimer = ref} {...this.props} />
        <Section title="Timer">
          <Flex variant="vSpace" align="stretch" direction="column">
            {BaseTimerEditor.getDisplayTypeDropdown( timerObj, this.changePath )}
            <LabelGroup>
              <label />
              <label>
                <div className="checkbox">
                  <label>
                    <input type="checkbox" checked={timerObj.runImmediately} onClick={this.onRunImmediatelyClick} />
                    Run Immediately
                  </label>
                </div>
              </label>
            </LabelGroup>
            <LabelGroup>
              <label>Delay (ms)</label>
              <NumericInput
                float
                value={timerObj.delay}
                changeOnReturn
                size={10}
                onChange={( v, err ) => { this.baseTimer.changePath( 'timer/delay', v, err ) }} />
            </LabelGroup>
          </Flex>
        </Section>
        { TimerActionFactory.createEditor( timer.action, { ...this.props } ) }
        { BaseTimerEditor.getDisplayContext( timer, currentContext ) }
      </div>
    )
  }

}
